import * as API from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

const createInsertionOrder = async (ioData) => {
  try {
    const res = await API.create_insertion_order(ioData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const updateInsertionOrder = async (ioID, ioData) => {
  try {
    const res = await API.update_insertion_order(ioID, ioData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const getInsertionOrderDetails = async (ioID) => {
  try {
    const res = await API.insertion_order_details(ioID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const getInsertionOrderList = async (
  pageNum,
  filters,
  searchString,
  sortField,
  sortOrder,
) => {
  try {
    const res = await API.insertion_order_list(
      pageNum,
      filters,
      searchString,
      sortField,
      sortOrder,
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const getInsertionOrderHistory = async (ioID, sortField, sortOrder, page, pageSize) => {
  try {
    const res = await API.insertion_order_history(ioID, sortField, sortOrder, page, pageSize);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const deleteInsertionOrder = async (ioID) => {
  try {
    const res = await API.delete_insertion_order(ioID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const downloadInsertionOrder = async (publisherId) => {
  try {
    const res = await API.download_insertion_order(publisherId);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export {
  createInsertionOrder,
  updateInsertionOrder,
  getInsertionOrderDetails,
  getInsertionOrderList,
  getInsertionOrderHistory,
  deleteInsertionOrder,
};
